"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconExpressOrder = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var IconExpressOrder = function IconExpressOrder(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.595 12.856c0 .232-.07.464-.197.638L6.6 22.19a1.15 1.15 0 01-.962.522H2.16c-.638 0-1.16-.522-1.16-1.16 0-.231.07-.463.197-.637l5.369-8.059-5.369-8.059A1.096 1.096 0 011 4.16C1 3.522 1.522 3 2.16 3h3.478c.406 0 .754.209.962.522l5.798 8.696c.128.174.197.406.197.638z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24.19 12.856c0 .232-.069.464-.196.638l-5.798 8.696a1.152 1.152 0 01-.962.522h-3.48a1.163 1.163 0 01-1.159-1.16c0-.231.07-.463.198-.637l5.368-8.059-5.368-8.059a1.09 1.09 0 01-.198-.637c0-.638.522-1.16 1.16-1.16h3.479c.405 0 .753.209.962.522l5.798 8.696c.127.174.197.406.197.638z"
  }));
};
exports.IconExpressOrder = IconExpressOrder;